import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { anexo7_item } from "../../../../json/anexo7CAF";


const Anexo = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="container transparencia-container">
      <div className="row">
        <div className="col-12">
          <div className="transparencia_title">
            <h1>Anexo 7CAF</h1>
            <hr className="tramitehr" />
          </div>
        </div>
      </div>
      <div className="row">
          {anexo7_item.map((item, index) => (
             <div className="col-md-4 mb-4" key={index}>
                <div className="card card_new">
                  <div className="card-header text-center text-from-cards text-primary">Ejercicio {item.ejercicio}</div>
                  <div className="card-body">       
                    <ul>
                      {item.items_anexos.map((itemA, indexA) => (
                        <li style={{ listStyleType: "none" }} key={indexA}>
                            <span className="badge bg-primary">
                              .pdf
                            </span>   
                            <a href={itemA.anexos_item_url} target="_blank" rel="noopener noreferrer">{itemA.anexos_item_nombre}</a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
          ))}
      </div>
    </div>
  );
};

export default Anexo;
